export default [
    {
        path: '/integrations/config',
        name: 'integrations-config',
        component: () => import ('./views/Index'),
        meta: {
            title: 'Configurações de integrações',
            icon: 'mdi-database-cog',
            breadcrumbs: [
                { text: 'Descrição da rota', disabled: true }
            ]
        }
    },
]
